import { FINANCIAL_PORTAL } from '../../../../api/endpoints';
import request from '../../../../api/request';

import {
  CreateRefundChargePayload,
  CreateRefundPayload,
  EligibleDebt,
  Refund,
  RefundCharge,
} from './types';

/**
 * HU-15411: listado de devoluciones registradas para el estudiante.
 */
export function listRefunds(studentId: number) {
  const URL = FINANCIAL_PORTAL.REFUNDS_BY_STUDENT(studentId);
  return request<Refund[]>(URL, { method: 'GET' });
}

/**
 * HU-15411: crea una nueva devolución en estado INGRESADA.
 */
export function createRefund(studentId: number, body: CreateRefundPayload) {
  const URL = FINANCIAL_PORTAL.REFUNDS_BY_STUDENT(studentId);
  return request<Refund>(URL, { method: 'POST', data: body });
}

/**
 * HU-15415: crea un cargo (TRANSFER | DISCOUNT) sobre una devolución.
 * El backend valida saldo y suma de allocations dentro de una transacción.
 */
export function createRefundCharge(
  refundId: string,
  body: CreateRefundChargePayload,
) {
  const URL = FINANCIAL_PORTAL.REFUND_CHARGES(refundId);
  return request<RefundCharge>(URL, { method: 'POST', data: body });
}

/**
 * HU-15415: historial de cargos aplicados a una devolución.
 */
export function listRefundCharges(refundId: string) {
  const URL = FINANCIAL_PORTAL.REFUND_CHARGES(refundId);
  return request<RefundCharge[]>(URL, { method: 'GET' });
}

/**
 * HU-15415: deudas vigentes (amount > 0) del estudiante para el sub-form
 * DISCOUNT. Vienen ordenadas por fecha de vencimiento ascendente.
 */
export function listEligibleDebts(studentId: number) {
  const URL = FINANCIAL_PORTAL.REFUND_DEBTS_ELIGIBLE(studentId);
  return request<EligibleDebt[]>(URL, { method: 'GET' });
}
